




















import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import { Select as HourSelect, DatePicker } from '@/components/form';
import { format } from 'date-fns';
import {
  ITimePeriodsByDates,
  ITimePeriodsByDatesItem,
} from '@/pages/activities/card/types';
import { Options } from '@/pages/activities/card/order/types';

@Component({
  components: {
    DatePicker,
    HourSelect,
  },
})
export default class PagesActivitesOrderDatepicker extends Vue {
  @Prop({ type: Date, required: true })
  value: Date;

  @Prop({ type: [String, Number], required: false })
  selectedTimeId: number | null;

  @Prop({ type: String, default: '' })
  select: string;

  @Prop({ type: Object, default: null })
  activeDates: any;

  @Prop({ type: Object, default: null })
  disabledDates: any;

  @Prop({ type: Boolean, default: false })
  flag: boolean;

  @Prop({ type: Object, default: null })
  timePeriodsByDates: ITimePeriodsByDates | null;

  timeId: number | null = null;

  get options() {
    let result: Options;
    if (!this.timePeriodsByDates) {
      result = [
        {
          value: 0,
          text: 'нет записей',
        },
      ];
    } else {
      const currentTimePeriods: Array<ITimePeriodsByDatesItem> =
        this.timePeriodsByDates[format(this.value, 'YYYY-MM-DD')];
      result = currentTimePeriods.map((item: ITimePeriodsByDatesItem) => ({
        ...item,
        value: item.id,
        text: item.timePeriodLabel,
      }));
    }
    return result;
  }

  @Watch('timeId')
  changeTime() {
    this.$emit(
      'update:selectedTimeItem',
      this.timeId
        ? this.options.find((item: any) => item.value === this.timeId)
        : null
    );
  }

  mounted() {
    this.timeId = !this.selectedTimeId
      ? this.options.length > 0
        ? this.options[0].value
        : null
      : this.selectedTimeId;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/orders/OrderDatepicker.vue